"use client";

import { useTranslations } from "next-intl";

const Loading = () => {
  const t = useTranslations("Loading");
  // Or a custom loading skeleton component
  return (
    <div className="flex flex-col items-center justify-items-center min-h-screen p-8 pb-20 gap-16 sm:p-20 font-[family-name:var(--font-geist-sans)]">
      <span>{t("title")}</span>
      <span>{t("description")}</span>
    </div>
  );
};

export default Loading;
